// @flow
import styled from 'styled-components';
import colors from '../../assets/css/colors';
import { TableFlexRow } from '../';

export const BenchTitle = styled(TableFlexRow)`
	font-size: 12px;
	font-weight: bold;
	line-height: 1.5;
	text-align: center;
	justify-content: center;
	text-transform: uppercase;
	color: ${colors.darkGrey};
	background: ${colors.lightGrey};
	height: 20px;
`;

export default BenchTitle;


// WEBPACK FOOTER //
// ./src/components/Team/BenchTitle.js